import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import nebulaTheme from '@nebula/theme';
import { InfoIcon } from '@nebula/icons/ui';
import Analytics, { MilestoneInputEvent } from '@ecs-uk/web-common-analytics';
import {
  Container,
  IconContainer,
  StyledBodyMedium400,
  StyledTitleSmall500,
  TextContainer,
} from '../ResultStage/index.styles';
import { BodyContent, TryAgainButton } from './index.styles';
import { CANCELLATION_TYPES } from '../../constants';
import usePageView from '../../../../hooks/usePageView';

export default function ErrorStage({ onTryAgain, subscriptionFamily, isDeferred, isImmediate }) {
  const [hasPublishedEvent, setHasPublishedEvent] = useState(false);

  const PAGE_NAME = 'ProdMoveCoolingOffErrorPage';

  usePageView(PAGE_NAME);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!hasPublishedEvent) {
      let cancellationType = 'not_set';
      if (isDeferred) {
        cancellationType = CANCELLATION_TYPES.DEFERRED;
      } else if (isImmediate) {
        cancellationType = CANCELLATION_TYPES.IMMEDIATE;
      }

      const productMovementErrorEvent = MilestoneInputEvent.fromObject({
        product_movement_error: {
          family: subscriptionFamily,
          cancellationType,
          error: 'downsell_failed',
        },
      });

      Analytics.publish(productMovementErrorEvent);
      setHasPublishedEvent(true);
    }
  }, [hasPublishedEvent, subscriptionFamily, isDeferred, isImmediate]);

  return (
    <Container>
      <BodyContent>
        <IconContainer>
          <InfoIcon iconSize="large" iconColor={nebulaTheme.color.ui.grey[100]} />
        </IconContainer>
        <TextContainer>
          <StyledTitleSmall500>We could not show your information</StyledTitleSmall500>
          <StyledBodyMedium400>It was an issue at our end. You have not been charged.</StyledBodyMedium400>
        </TextContainer>
        <TryAgainButton label="Try again" onClick={onTryAgain} />
      </BodyContent>
    </Container>
  );
}

ErrorStage.propTypes = {
  onTryAgain: PropTypes.func.isRequired,
  subscriptionFamily: PropTypes.string.isRequired,
  isDeferred: PropTypes.bool.isRequired,
  isImmediate: PropTypes.bool.isRequired,
};
